/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import React from 'react'

import { DSAPIContext, DSAPIProvider } from './DSAPIProvider'
import {
  Annotation,
  AnnotationData,
  BinBounds,
  BinBoundsData,
  DamageAnnotation,
  DamageAnnotationData,
  toggleApprovedDamageAnnotation,
} from './toggleApprovedDamageAnnotation'
import { triggerInspectionEditPipeline } from './triggerInspectionEditPipeline'

export function useRegenerateRawData() {
  const { authorizedAxios: axios } = useGeckoAuth()
  const { DS_API_URL } = useRuntimeVariables()

  return React.useMemo(() => {
    return {
      regenerateRawData: async (slug: string) =>
        await axios.post(
          `${DS_API_URL}/api/v1/pipelines/${slug}/forecast`,
          undefined,
          { headers: { 'Content-Type': 'application/json' } }
        ),
    }
  }, [axios, DS_API_URL])
}

export {
  type Annotation,
  type AnnotationData,
  type BinBounds,
  type BinBoundsData,
  type DamageAnnotation,
  type DamageAnnotationData,
  DSAPIContext,
  DSAPIProvider,
  toggleApprovedDamageAnnotation,
  triggerInspectionEditPipeline,
}
